var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"records-toolbar"},[_c('span',{staticClass:"record-count-badge"},[_vm._v(" Total de "),_c('strong',[_vm._v(_vm._s(_vm.total))]),_vm._v(" "+_vm._s(_vm.total === 1 ? 'registro' : 'registros')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }